import './js/AppBase';
import './js/Memberstack';
import './js/SignupRole';
import './js/PasswordField';
import './js/PasswordMatch';
import './js/CoapplicantsForm';
import './js/ApplicantAgents';
import './js/AgentSignup';
import './js/FormSteps';
import './js/RepeaterFields';
import './js/ProgramGuide';
import './js/ProfileEdit';
import './js/Modal';
import './js/PrequalificationForm';
import './js/PaymentSuccess';
import './js/Prescreening';
import './js/OfferRequestForm';
import './js/Tabs';
import './js/OffersTable';
import './js/DashboardStartNav';
import './js/SupportForm';
import './js/Toast';
import './js/CoappsTable';
import './js/MyAgentsTable';
import './js/AgentClientsTable';
import './js/UploadTable';

console.log('gr app: ', window.grapp);